import { useDispatch, useSelector } from 'react-redux'
import classes from './DocumentListItem.module.css'
import { useEffect, useState } from 'react'
import { detailsActions } from '../../../../../store/details'
import { TAB_IDS } from '../../../../../assets/data'
import { documentsActions } from '../../../../../store/documents'

const DocumentListItem = ({data}) => {
    const dispatch = useDispatch()
    const [isUploaded, setIsUploaded] = useState(false)
    const activeCase = useSelector(state => state.case.activeCase) 


    useEffect(() => {       
        let documents
        if (activeCase) {            
            if (activeCase.documents && activeCase.documents.length > 0) {
                documents = activeCase.documents
            }
        }
        if (documents) {                
            documents.forEach(element => {
                if (element.document_type_id == data?.value) {
                    setIsUploaded(true) 
                } 
            });
        }

    }, [activeCase])

    const uploadDocumentHandler = () => {
        dispatch(detailsActions.setActiveTab(TAB_IDS.DOCUMENTS))
        dispatch(documentsActions.setTriggerFileUpload(data?.id))
    }

    if (isUploaded) {
        return <div className={`${classes.item} ${classes.item_done}`}>
            <span className={`${classes.icon} ${classes.icon_done}`}>
                <i className="ti ti-file-check"></i>
            </span>
            {data?.data?.name}
        </div>
    }

    return <div className={`${classes.item}`}>
        <span className={`${classes.icon}`}>
            <i className="ti ti-file-alert"></i>
        </span>
        <button className={classes.button} onClick={uploadDocumentHandler}>{data?.data?.name}</button>
    </div>
}

export default DocumentListItem